"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
exports.ErrorRecord = immutable_1.Record({
    id: '',
    sourceId: '',
    subSection: '',
    type: '',
    context: '',
    errorMessage: '',
});
var Error = /** @class */ (function (_super) {
    __extends(Error, _super);
    function Error(props) {
        return _super.call(this, props) || this;
    }
    return Error;
}(exports.ErrorRecord));
exports.Error = Error;
;
exports.ValidationResultRecord = immutable_1.Record({
    passedValidation: true,
    errors: immutable_1.List([])
});
var ValidationResult = /** @class */ (function (_super) {
    __extends(ValidationResult, _super);
    function ValidationResult(props) {
        return _super.call(this, props) || this;
    }
    return ValidationResult;
}(exports.ValidationResultRecord));
exports.ValidationResult = ValidationResult;
;
//# sourceMappingURL=form-validation-definition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-validation-definition.js
// module id = 1105
// module chunks = 0